/*  Add copy and paste Mar 13, 2022 */
<template lang="pug">
	div(class="kt-attach")
		//- Header
		kt-spinner(v-if="d_loading" p_txt="Documents")
		div(class="kt-attach-header")
			div(class="small flex-grow-1")
				b-button(class="btn-add-folder" title="Create New Folder" variant="primary" @click="m_createFolderClick")
					fa-icon(icon="folder-plus")
					|  Create Folder
				b-button(class="btn-upload" title="Upload New" variant="primary" @click="m_uploadFilesClick")
					fa-icon(icon="upload")
					|  Upload File(s)
				input(v-show="false" ref="file-upload" id="file-upload" type="file" multiple  @change="m_fileUploadChange")
			div(class="small")
				//- input(class="inpt-search" type="search" placeholder="Search Files and Folders" @search="m_search")
				b-button(class="btn-download" variant="outline-secondary" @click="d_rootNode.fn_download()"
					v-b-tooltip:dragbox.hover.topleft.ds500="'Download all (as zip)'")
					fa-icon(icon="download")
				b-button(class="btn-refresh" title="Refresh" v-b-tooltip:dragbox.hover.topleft.ds500="Refresh" variant="outline-secondary" @click="m_refreshClick")
					fa-icon(icon="sync")
		div(class='kt-attach-main')
			//- Folder Map
			div(class="folder-map")
				div
					fa-icon(icon="folder-open")
					span(class="btn btn-link" @click="d_rootNode.fn_openFolder()") {{d_rootNode.name}}
				div(v-for="(fldr, ix) in c_folderMap" :key="ix")
					fa-icon(icon="chevron-right")
					span(class="btn btn-link" @click="fldr.fn_openFolder()") {{fldr.name}}
				div(class="btns")
					b-button(class="btn-paste" id="btn-paste" variant="outline-primary"  @click="m_pasteFiles" v-b-tooltip:dragbox.hover.topleft.ds500="m_copiedFiles")
						fa-icon(icon="paste")
					b-button(class="btn-show-hrchy" variant="outline-primary"  @click="m_showFolderHrchy" v-b-tooltip:dragbox.hover.topleft.ds500="'Show Folder Hierarchy'")
						fa-icon(icon="sitemap")
			//- Loading
			//kt-spinner(v-if="d_loading" p_txt="Documents")
			//- Dragbox
			div(id="dragbox" @dragover="m_dragover" @dragleave="m_dragleave" @drop="m_drop"
				:class="d_inDrag?'dragover':null")
				//- FIles/Folders List
				kt-attach-node(v-for="(childNode, ix) in d_currNode.nodes" :key="ix" :p_node="childNode" v-show="!d_loading")
			
				//- Note
				div(class="note")
					span(v-if="d_currNode.nodes.length == 0 & !d_loading") This Folder is Empty
					div(v-if="c_isTouch" @click="m_uploadFilesClick")
						fa-icon(icon="upload")
						span() Select file(s) to upload
					div(v-else)
						fa-icon(icon="upload")
						span Drag and drop file(s) to upload

			
		//- Folder Hierarchy
		b-modal(id="bm-kt-attach-fldr-hrchy" size="md" ok-variant="outline-secondary" hide-header-close 
			centered no-fade no-close-on-backdrop ok-only footer-class="justify-content-start" 
			:ok-title="d_mvNode.clntId?'Cancel':'Close'"
			@cancel="d_fldrHrchy=[]; d_mvNode={}")
			template(slot="modal-header")
				span(v-if="d_mvNode.clntId") Select a destination folder to which you want to move the {{d_mvNode.typeLbl}}
				span(v-else) Selct a folder to navigate to
			div(v-for="(f,ix) in d_fldrHrchy" :key="ix" :style="'margin-left:' + f.lvl*20 + 'px'" :disabled="f.disabled")
				span {{f.node.isRoot ? '':'↳ '}}
				fa-icon(icon="folder-open")
				span(class="btn btn-link" @click="m_hrchyNodeClick(f.node)") {{f.node.name}} 
				span {{f.node.fn_nodesCntTxt()}}
				small(v-if="f.node.clntId == d_mvNode.clntId") (The folder being moved)
				small(v-else-if="f.node.clntId == (d_mvNode.parent||{}).clntId") (Current location of the {{d_mvNode.typeLbl}})
				small(v-else-if="f.node.clntId == d_currNode.clntId") (Current folder)
		//- File Viewer
		b-modal(id="bm-kt-attach-file-view" size="xl" ok-variant="outline-secondary" hide-header-close 
			centered no-fade no-close-on-backdrop footer-class="justify-content-start"
			:body-class="'mt-'+d_vwNode.mediaType"
			@hide="d_vwNode={}"
		)
			template(slot="modal-header")
				span Viewing "{{d_vwNode.name}}.{{d_vwNode.extension}}"
			
			img(v-if="d_vwNode.mediaType =='image'"  :src="d_vwNode.vwData")
			pre(v-else-if="d_vwNode.extension == 'bat'") {{d_vwNode.vwData}}
			iframe(v-else :src="d_vwNode.vwData" :type="d_vwNode.contentType" width="100%" height="100%" frameBorder="0")
			template(slot="modal-footer" slot-scope="{ ok, cancel, hide }")
				b-button(variant="outline-secondary" @click="cancel()") Close
				span(class="btn btn-sm btn-link py-0" @click="M-m_fileViewNewTab()")  Open in New Tab
</template>

<script>


import util, {kbdpAlert} from "@/utils/util.js";
import {fn_appEnt} from "@/utils/ref-data.js";
import KTAttachNode from "@/components/Ctrl/KT-AttachNode.vue";
import {attachments as api} from "@/utils/api.js";
export default {
	name: "kt-attach",
	components: {
		'kt-attach-node': KTAttachNode
	},
	created() {
		this.d_rootNode = this.d_currNode = new AttachNode(this.c_rootRecLbl, [], null, this);
		this.d_rootNode.isOpen = true;
		

		fn_getData(this);
	},
	mounted() {
	
	document.querySelector("#btn-paste").addEventListener('dblclick', function() {
			window.sessionStorage.removeItem('copiedFiles');
			window.sessionStorage.removeItem('copiedFileNames');
		})
	},
	data() {
		return {
			d_prntAppEnt: fn_appEnt(this.p_prntRecKey),
			d_rootNode: {},
			d_currNode: {},
			d_mvNode: {},
			d_vwNode: {},

			d_fldrHrchy: [],
			d_loading: null,
			d_inDrag: null,
			d_copiedFiles: [],
		};
		
		
	},
	props: {
		p_prntRecKey: String, //==> oppr, proj, acct
		p_recInfo: Object,
	},
	computed: {
		c_copiedFiles() {
		var copiedFileNames=window.sessionStorage.getItem('copiedFileNames');
		if ((copiedFileNames) && (copiedFileNames != undefined))	
			return 'Paste: '+ copiedFileNames;
		else return 'Paste';  
		},    
		c_label() {
			return util.fn_humanizeLabel(this.d_prntAppEnt.name + 'Attachment');
		},
		c_rootRecLbl() {
			let ri = this.p_recInfo;
			return util.fn_recLbl(ri.No, ri.Name);
		},
		c_folderMap() {
			let map = [];
			fn_littleHelper(this.d_rootNode.nodes);
			function fn_littleHelper(cn) {
				cn.filter(n => n.isFolder && n.isOpen).forEach(n => {
					map.push(n);
					fn_littleHelper(n.nodes);
				});
			}
			return map;
		},
		c_isTouch() {
			return this.$root.$children[0].d_isTouch;
		}
	},
	methods: {
		m_createFolderClick(e) {
			if (e.detail > 1) return;
			this.d_currNode.fn_addFolder();
		},
		m_uploadFilesClick() {
			let fu = this.$refs['file-upload'];
			fu.value = null;
			fu.click();
		},
		m_refreshClick() {
			fn_getData(this);
		},

		m_showFolderHrchy() {
			this.d_mvNode = {};
			fn_setFoldersHrchy(this);
			this.$bvModal.show('bm-kt-attach-fldr-hrchy');
		},
		m_hrchyNodeClick(node) {
			let mn = this.d_mvNode;
			if (mn.clntId) {
				mn.fn_moveTo(node);
			}
			else {
				this.d_currNode.isOpen = false;
				this.d_currNode.fn_toggleAncestors(null);
				node.fn_openFolder();
			}
			this.$bvModal.hide('bm-kt-attach-fldr-hrchy');
		},

		m_fileUploadChange(e) {
			var vFiles=[];
			var vFile={};
			var files=e.target.files;	
			for (var x = 0; x < files.length; x++)
					{vFile=files[x];	
					vFiles.push(vFile);
					}
			fn_fileUploadHandler(this, vFiles);
		},
		m_dragover(e) {
			e.preventDefault();
			this.d_inDrag = true;
		},
		m_dragleave(e) {
			e.preventDefault();
			let isdb = e.target.id == 'dragbox';
			if (isdb) {
				this.d_inDrag = null;
			}
		},
		m_drop(e) {
			e.preventDefault();
			this.d_inDrag = null;
			var vFiles=[];
			var vFile={};
			var files=e.dataTransfer.files;	
			for (var x = 0; x < files.length; x++)
					{vFile=files[x];	
					vFiles.push(vFile);
					}
			fn_fileUploadHandler(this, vFiles);
		},

		m_fileViewNewTab() {
			let a = document.createElement("a");
			a.setAttribute('href', this.d_vwNode.vwData);
			a.setAttribute('target', '_blank');
			a.click();
			// this.$bvModal.hide('bm-kt-attach-file-view');
		},
		
		m_pasteFiles(){
		
		this.isLoading = true;
		//let copiedFileNames=window.sessionStorage.getItem('copiedFileNames');
		let copiedAttachments=window.sessionStorage.getItem('copiedFiles');
		if(copiedAttachments){
		let attachments=copiedAttachments.split(' ');
		var attachmentObjects=[];
		attachments.forEach(a=>{
								var attachmentObject={};
								attachmentObject["attachmentId"]=a;
								attachmentObjects.push(attachmentObject);
								});
		let params = {
				recordContext: this.d_prntAppEnt.name,
				recordId: this.p_recInfo.Id,
				attachmentFolderId: this.d_currNode.attachmentFolderId,
				attachments: attachmentObjects
				};
				
		
		api.fn_copyAttachment(params).then(resp => {
			if (resp.error) {
				let msg = `Unable to create files` + (resp.error || "");
				kbdpAlert.showErr(msg);
				this.isLoading = null;
				return;
			}
			
			this.isLoading = null;
			var msg;
			if(attachments.length==1) msg= attachments.length+' file copied successfully'; else msg=attachments.length+' files copied successfully';
			kbdpAlert.showOk(msg);
			this.m_refreshClick();
			window.sessionStorage["copiedFiles"] = '';
			window.sessionStorage["copiedFileNames"] = '';
				
			}) 
			
		
		} else kbdpAlert.showErr('No attachments to paste');
	},
	m_copiedFiles() {
		var copiedFileNames=window.sessionStorage.getItem('copiedFileNames');
		if ((copiedFileNames) && (copiedFileNames != undefined))	
			return 'Paste: '+ copiedFileNames;
		else return 'Paste';  
		},
	},
	watch: {

	},
	beforeDestroy() {
		fn_littleHelper(this.d_rootNode.nodes);
		function fn_littleHelper(nodes) {
			nodes.forEach(x => {
				if (x.vwData) {
					console.log('revokeObjectURL', x.vwData);
					URL.revokeObjectURL(x.vwData);
				}
				else if (x.isFolder) {
					fn_littleHelper(x.nodes);
				}
			});
		}
	}
};

class AttachNode {
	constructor (nodeName, childNodes, parentNode, vc) {
		this.vcRef = vc;
		this.clntId = Date.now() * Math.random();
		this.name = nodeName;
		this.nodes = childNodes;

		this.parent = parentNode;
		this.isRoot = parentNode == null;
		this.isFolder = childNodes != null;

		//must set a null value for reactivity
		this.isOpen = null;
		this.isLoading = null;
		this.isError = null;
		this.typeLbl = this.isFolder ? 'folder' : 'file';

		this.isDupNm = null;
		this.vwData = null;


		this.attachmentId = null;
		this.attachmentFolderId = null;
		this.size;
		this.extension;
		this.contentType;
		this.mediaType;
		this.addedById;
		this.addedUTC;
		this.updatedById;
		this.updatedByUTC;
	}


	fn_addFolder() {
		if (!this.nodes) return;

		// let fn = fn_NewFolderName('New Folder', this.nodes);

		let f = new AttachNode('New Folder', [], this, this.vcRef);
		this.nodes.push(f);
	}
	fn_addFile(file, isLoading) {
		if (!this.nodes) return;

		let nodeName = file.name.substring(file.name.lastIndexOf('.'), 0).substring(0, 100);

		let fileNode = new AttachNode(nodeName, null, this, this.vcRef);

		fileNode.extension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
		fileNode.size = file.size;
		if (isLoading) fileNode.isLoading = true;



		let dup = this.nodes.filter(x => !x.isFolder && x.name == nodeName)[0];
		if (dup) {
			// let n = this.nodes.filter(x => !x.isFolder && x.name.startsWith(nodeName)).length;
			fileNode.isDupNm = true;
		}
		this.nodes.push(fileNode);


	}
	fn_openFolder() {
		if (!this.isFolder) return;
		if (this.parent) {//"Close" Sibling folders
			this.parent.nodes.filter(n => n.isFolder).forEach(n => n.isOpen = null);
		}
		this.fn_toggleAncestors(true); //Open Ancestors
		this.fn_toggleDescedants(null); //Close Descendants
		this.isOpen = true;
		this.vcRef.d_currNode = this;
	}
	fn_openFile() {
		if (this.isFolder) return;

		let _this = this;

		if (_this.vwData) {
			_this.vcRef.d_vwNode = _this;
			_this.vcRef.$bvModal.show('bm-kt-attach-file-view');
			return;
		}

		if (_this.isLoading) return;
		_this.isLoading = true;
		api.fn_dlAttch(this.attachmentId).then(resp => {
			if (resp.error) {
				let msg = `Unable to open file` + (resp.error || "");
				kbdpAlert.showErr(msg);
				_this.isLoading = null;
				return;
			}

			let ct = resp.contentType;
			_this.contentType = ct;
			// _this.mediaType = ct.substring(0, ct.indexOf('/'));

			if (fn_canViewFile(this)) {
				// _this.vwData = `https://view.officeapps.live.com/op/embed.aspx?src=${resp.objUrl}`;
				this.vwData = resp.objUrl;
				_this.vcRef.d_vwNode = _this;
				_this.vcRef.$bvModal.show('bm-kt-attach-file-view');
			}
			else {
				let fileName = _this.name + '.' + _this.extension;
				let a = document.createElement("a");
				a.setAttribute('href', resp.objUrl);
				a.setAttribute('download', fileName);
				a.click();
				a.remove();
			}
			_this.isLoading = null;
		});
	}
	fn_toggleAncestors(open) {
		let prnt = this.parent;
		if (prnt) {
			prnt.isOpen = open;
			if (!prnt.isRoot) {
				prnt.fn_toggleAncestors(open);
			}
		}
	}
	fn_toggleDescedants(open) {
		if (!this.nodes) return;
		this.nodes.forEach(cn => {
			if (cn.isFolder) {
				cn.isOpen = open;
				cn.fn_toggleDescedants(open);
			}
		});
	}



	fn_saveChanges() {
		if (this.isFolder) fn_saveData_attachmentFolder(this.vcRef, this, null);
		else fn_saveData_attachmentFile(this.vcRef, this, null);
	}
	fn_download() {
		let _this = this;
		if (_this.isLoading) return;

		_this.isLoading = true;

		if (_this.isFolder) {

			if (_this.nodes.length == 0) {
				kbdpAlert.showErr('The folder is empty. There is nothing to download');
				_this.isLoading = null;
				return;
			}

			let dlmsg = 'Preparing download...';
			if (_this.isRoot) {
				let vc = _this.vcRef;
				let content = {
					titleText: 'Confirm Download',
					message1: `Are you sure you want to download ALL folders and files under this ${vc.d_prntAppEnt.name}?`,
				};
				let cm = util.fn_getModal_confirm(vc, content);
				vc.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then(resp => {
					if (resp) {
						kbdpAlert.showLoading(dlmsg);
						fn_dlHelper();
					}
					else _this.isLoading = null;
				});
			}
			else {
				kbdpAlert.showLoading(dlmsg);
				fn_dlHelper();
			}
		}
		else {
			api.fn_dlAttch(this.attachmentId).then(resp => {
				if (resp.error) {
					let msg = `Unable to download file` + (resp.error || "");
					kbdpAlert.showErr(msg);
					_this.isLoading = null;
					return;
				}
				_this.contentType = resp.contentType;
				let fileName = _this.name + '.' + _this.extension;
				let a = document.createElement("a");
				a.setAttribute('href', resp.objUrl);
				a.setAttribute('download', fileName);
				a.click();
				a.remove();
				_this.isLoading = null;
			});
		}




		function fn_dlHelper() {
			let params = {
				recordContext: _this.vcRef.d_prntAppEnt.name,
				recordId: _this.vcRef.p_recInfo.Id,
				attachmentFolderId: _this.attachmentFolderId || null,
			};
			api.fn_dlAttchFldr(params).then(resp => {
				if (resp.error) {
					let msg = `Unable to download folder. ` + (resp.error || "");
					kbdpAlert.showErr(msg);
					_this.isLoading = null;
					return;
				}
				let fileName = _this.name + '.zip';
				let a = document.createElement("a");
				a.setAttribute('href', resp.objUrl);
				a.setAttribute('download', fileName);
				a.click();
				a.remove();
				_this.isLoading = null;

				kbdpAlert.clear();
			});
		}

	}
	fn_moveTo(destNode) {
		let vc = this.vcRef;
		let bmId = "bm-kt-attach-fldr-hrchy";
		if (!destNode) {
			//Open Move To dialogue
			vc.d_mvNode = this;
			fn_setFoldersHrchy(vc);
			vc.$bvModal.show(bmId);
		}
		else {
			//Perform the Move
			let mn = vc.d_mvNode;
			destNode.nodes.push(mn);

			let ix = mn.parent.nodes.map(x => x.clntId).indexOf(mn.clntId);
			mn.parent.nodes.splice(ix, 1);

			mn.parent = destNode;
			mn.fn_saveChanges();

			vc.d_mvNode = {};
		}
	}
	fn_delete() {
		let vc = this.vcRef;

		if (this.isError) {
			let ix = this.parent.nodes.map(x => x.clntId).indexOf(this.clntId);
			this.parent.nodes.splice(ix, 1);
			return;
		}

		if (this.isFolder) {

			if (this.nodes.length == 0) {
				if (this.attachmentFolderId) {
					fn_saveData_attachmentFolder(vc, this, true);
				}
				else {
					let ix = this.parent.nodes.map(x => x.clntId).indexOf(this.clntId);
					this.parent.nodes.splice(ix, 1);
				}
				if (vc.d_currNode.clntId == this.clntId) vc.d_currNode = this.parent;
				return;
			}
			let childFolders = this.nodes.filter(x => x.isFolder).length;
			if (childFolders > 0) {
				let msg = `Please delete the ${childFolders} nested folder(s) first and try again.`;
				kbdpAlert.showErr(msg);
				return;
			}
			else {
				kbdpAlert.clear();
			}

			let childFiles = this.nodes.filter(x => !x.isFolder).length;
			let content = {
				titleText: 'Confirm Delete Folder',
				message1: `Are you sure you want to delete the folder "${this.name}"?`,
				message2: `The ${childFiles} file(s) in this folder will also be deleted.`
			};

			let cm = util.fn_getModal_confirm(vc, content);
			cm.opt.okTitle += ', Delete';
			cm.opt.cancelTitle += ', Keep';
			vc.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then(resp => {
				if (!resp) return;
				fn_saveData_attachmentFolder(vc, this, true);
				if (vc.d_currNode.clntId == this.clntId) vc.d_currNode = this.parent;
			});
		}
		else {
			let content = {
				titleText: 'Confirm Delete File',
				message1: `Are you sure you want to delete the file "${this.name}"?`,
			};
			let cm = util.fn_getModal_confirm(vc, content);
			cm.opt.okTitle += ', Delete';
			cm.opt.cancelTitle += ', Keep';
			vc.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then(resp => {
				if (!resp) return;
				fn_saveData_attachmentFile(vc, this, true);
			});
		}

	}


	fn_icon() {

		if (this.isFolder) return 'folder-open';
		let ext = this.extension;
		let mt = this.mediaType;
		if (/^(pdf)$/.test(ext)) return 'file-pdf';
		if (/^(doc|docx)$/.test(ext)) return 'file-word';
		if (/^(xls|xlsx)$/.test(ext)) return 'file-excel';
		if (/^(ppt|pptx)$/.test(ext)) return 'file-powerpoint';
		// if (/^(jpg|jpeg|png|bmp|tif|tiff|gif)$/.test(ext)) return 'file-image';
		if (/^(image)$/.test(mt)) return 'file-image';
		if (/^(zip|rar)$/.test(ext)) return 'file-archive';
		if (/^(csv)$/.test(ext)) return 'file-csv';
		// if (/^(txt)$/.test(ext)) return 'file-alt';
		if (/^(text)$/.test(mt)) return 'file-alt';
		return 'file';
	}
	fn_nodesCntTxt() {
		let n = this.nodes;
		let fld = n.filter(x => x.isFolder).length;
		let fil = n.length - fld;
		let p1 = (fld ? fld + ' folder' : '') + (fld > 1 ? 's' : '');
		let p2 = (fil ? fil + ' file' : '') + (fil > 1 ? 's' : '');
		return !p1 && !p2 ? 'empty folder' : p1 + ' ' + p2;
	}
	fn_fileSizeFmt() {
		return this.size ? util.fn_fmtFileSize(this.size) : '';
	}

}


function fn_getData(vc) {
	let recordContext = vc.d_prntAppEnt.name;
	let recordId = vc.p_recInfo.Id;
	vc.d_loading = true;
	api.fn_getAttch({recordContext, recordId}).then(resp => {
		vc.d_loading = null;
		if (resp.error) {
			let msg = `Unable to load Documents(s) ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		kbdpAlert.clear();

		vc.d_rootNode.nodes = [];
		//Root Parent Folders
		(resp.refData.attachmentFolders || []).filter(x => !x.parentId)
			.forEach(x => fn_folderHelper(resp, x, vc.d_rootNode));

		//Root Parent Files
		(resp.attachments || []).filter(x => !x.parentFolderId)
			.forEach(x => fn_fileHelper(x, vc.d_rootNode));

	});


	function fn_folderHelper(resp, fldr, prntNode) {
		let fldrNode = new AttachNode(fldr.name, [], prntNode, vc);
		fldrNode.attachmentFolderId = fldr.id;
		prntNode.nodes.push(fldrNode);

		(resp.refData.attachmentFolders || []).filter(x => x.parentId == fldr.id)
			.forEach(x => fn_folderHelper(resp, x, fldrNode));

		(resp.attachments || []).filter(x => x.parentFolderId == fldr.id)
			.forEach(x => fn_fileHelper(x, fldrNode));

	}

	function fn_fileHelper(att, prntNode) {
		let node = new AttachNode(att.attachmentName, null, prntNode, vc);
		node.attachmentId = att.attachmentId;
		node.size = att.size;
		node.contentType = att.contentType;
		node.addedById = att.addedById;
		node.addedUTC = att.addedUTC;
		node.updatedById = att.updatedById;
		node.updatedUTC = att.updatedUTC;


		let ct = node.contentType;
		node.mediaType = ct.substring(0, ct.indexOf('/'));

		let on = att.originalName;
		node.extension = on ? on.substring(on.lastIndexOf('.') + 1).toLowerCase() : '';
		prntNode.nodes.push(node);
	}
}
function fn_saveData_attachmentFolder(vc, folderNode, removed) {

	let params = {
		recordContext: vc.d_prntAppEnt.name,
		recordId: vc.p_recInfo.Id,
		attachmentFolderId: folderNode.attachmentFolderId,

		attachmentFolderName: folderNode.name,
		parentFolderId: (folderNode.parent.isRoot ? null : folderNode.parent.attachmentFolderId),
		removed: removed
	};


	folderNode.isLoading = true;
	api.fn_saveAttchFldr(params).then(resp => {
		if (resp.error || !resp.upsRecHdr) {
			let msg = `Unable to process requested change. ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			folderNode.isError = true;
			folderNode.isLoading = false;
			return;
		}
		let msg = `The folder "${folderNode.name}" was `;
		if (removed) {
			let ix = folderNode.parent.nodes.map(x => x.clntId).indexOf(folderNode.clntId);
			folderNode.parent.nodes.splice(ix, 1);
			msg += 'was deleted successfully';
		}
		else if (!folderNode.attachmentFolderId) {
			folderNode.attachmentFolderId = resp.upsRecHdr[0].attachmentFolderId;
			msg += 'created successfully';
		}
		else {
			msg += 'saved successfully';
		}
		kbdpAlert.showOk(msg);

		folderNode.isLoading = null;
	});
}
function fn_saveData_attachmentFile(vc, fileNode, removed) {

	let params = {
		recordContext: vc.d_prntAppEnt.name,
		recordId: vc.p_recInfo.Id,
		attachmentId: fileNode.attachmentId,
		attachmentName: fileNode.name,
		parentFolderId: (fileNode.parent.isRoot ? null : fileNode.parent.attachmentFolderId),
		removed: removed
	};

	fileNode.isLoading = true;
	api.fn_saveAttch(params).then(resp => {
		if (resp.error || !resp.upsRecHdr) {
			let msg = `Unable to process requested change. ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			fileNode.isError = true;
			fileNode.isLoading = null;
			return;
		}

		let msg = `The file "${fileNode.name}" was `;
		if (removed) {
			let ix = fileNode.parent.nodes.map(x => x.clntId).indexOf(fileNode.clntId);
			fileNode.parent.nodes.splice(ix, 1);
			msg += 'was deleted successfully';
		}
		else {
			msg += 'saved successfully';
		}
		kbdpAlert.showOk(msg);
		fileNode.isLoading = null;
	});
}

function fn_fileUploadHandler(vc, files) {
	let currentNode = vc.d_currNode;

	let filecount = 0;
	files.forEach(f => {
		let isFldr = !f.type && f.size % 4096 == 0;
		if (isFldr) return;
		currentNode.fn_addFile(f, true);
		filecount++;

	});

	if (filecount == 0) {
		kbdpAlert.showErr('Uploading folder(s) is not supported by the application. Please upload individual file(s) instead');
		return;
	}
	let params = {
		recordContext: vc.d_prntAppEnt.name,
		recordId: vc.p_recInfo.Id,
		recordNo: vc.p_recInfo.No,
		parentFolderId: currentNode.attachmentFolderId || null,
	};

	api.fn_upldAttch(files, params).then(resp => {
		if (resp.error || !resp.upsRecHdr) {
			let msg = `Unable to upload file(s) ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			currentNode.nodes.filter(f => f.isLoading).forEach(f => {
				f.isError = true;
				f.isLoading = false;
			});
			return;
		}

		let cnt = 0;
		currentNode.nodes.filter(x => !x.isFolder && x.isLoading).forEach(f => {
			let ups = resp.upsRecHdr.filter(x => !f.attachmentId && f.name == x.attachmentName)[0];
			if (ups) {
				f.attachmentId = ups.attachmentId;
				// f.addedUTC = ups.addedUTC;
				cnt++;
				f.isError = null;
			}
			else {
				f.isError = true;
			}
			f.isLoading = null;
		});


		let msg = cnt + " file(s) were uploaded successfully.";
		kbdpAlert.showOk(msg);
	});

}

function fn_setFoldersHrchy(vc) {
	let mn = vc.d_mvNode;
	let folders = [];
	fn_littleHelper([vc.d_rootNode], 0);
	vc.d_fldrHrchy = folders;

	function fn_littleHelper(nodes, lvl) {
		nodes.filter(node => node.isFolder).forEach(node => {
			if (mn.clntId) {
				let self = node.clntId == mn.clntId;
				let prntToMN = node.clntId == (mn.parent || {}).clntId;
				let chldToMN = mn.clntId == (node.parent || {}).clntId;
				let disabled = self || prntToMN;
				if (!chldToMN) {
					folders.push({node, lvl, disabled});
					fn_littleHelper(node.nodes, lvl + 1);
				}
			}
			else {
				let disabled = node.clntId == vc.d_currNode.clntId;
				folders.push({node, lvl, disabled});
				fn_littleHelper(node.nodes, lvl + 1);
				return;
			}
		});
	}
}

function fn_canViewFile(node) {
	let mt = node.mediaType;
	if (/^(image|text)$/.test(mt)) return true;

	let ct = node.contentType;
	if (/^application\/(pdf)$/.test(ct)) return true;

	else return false;
}
</script>

<style lang="less">
.kt-attach {
	.kt-attach-header {
		display: flex;
		padding: 0.4em 0;
		flex-wrap: wrap;
		> div {
			display: flex;
			line-height: 1;
		}

		.btn-add-folder,
		.btn-upload,
		.btn-download,
		.btn-refresh {
			font-size: 1em;
			padding: 0em 0.3em;
			margin-right: 0.5em;
		}
		.btn-download,
		.btn-refresh {
			width: 25px;
		}
		// .inpt-search {
		// 	padding: 0.1em 0.4em;
		// 	margin-right: 0.3em;
		// 	width: 160px;
		// 	outline: unset;
		// 	border: solid 0.1em #adb5bd;
		// 	font-size: 0.9em;
		// 	// border-radius: 0.25em;
		// 	&:focus {
		// 		box-shadow: 0em 0.01em 0.01em 0.05em #ced4da;
		// 	}
		// }
	}
	.kt-attach-main {
		background-color: #f8f9fa;
		border: solid 0.1em #adb5bd;
		border-radius: 0.25em;
		text-align: left;
		> div.folder-map {
			padding: 0.1em 0.4em;
			border-bottom: solid 0.1em #adb5bd;
			display: flex;
			flex-wrap: wrap;
			> div {
				display: inline-flex;
				margin: auto 0;
				&:first-child {
					svg.fa-folder-open {
						color: #4fa4ff;
					}
				}
				svg {
					font-size: 0.9em;
					margin: auto 0;
				}
				span.btn {
					font-size: 0.9em;
					text-align: left;
				}

				&:last-of-type .btn {
					text-decoration: underline;
					&:hover {
						color: #6c757d;
					}
				}
			}
			> div:last-child {
				margin-left: auto;
				display: flex;
		div.info {
			min-width: 85px;
			margin: auto 0;
			text-align: right;
			margin-left: auto;
			font-size: 0.8em;
		}
		div.btns {
			// border: solid 0.1em blue;
			min-width: 100px;
			max-width: 130px;
			text-align: right;
			padding: 0 0.2em;
			button.btn {
				font-size: 0.85em;
				padding: 0.3em 0.2em;
				margin: 0 0.1em;
				border-radius: 0.2em;
				line-height: 1em;
				opacity: 0.5;
				border: none;
				width: 20px;
				}
			}
		}
	}
		div#dragbox.dragover {
			border: dashed 0.2em #4fa4ff;
			background-color: #dee2e6;
			opacity: 0.5;

			div.note {
				color: #4fa4ff;
				svg.fa-upload {
					opacity: unset;
				}
			}
			> div {
				pointer-events: none;
				//Importat, Prevents drag leave when hovring inside dragboxx
			}
		}

		div.note {
			position: relative;
			padding: 1em 0;
			text-align: center;

			> span:first-child {
				padding: 1em 0;
			}
			> div {
				> svg.fa-upload {
					font-size: 1.5em;
					opacity: 0.5;
				}
				> span {
					display: block;
				}
			}
		}
	}
}

#bm-kt-attach-fldr-hrchy {
	.modal-header {
		display: block;
		padding: 0.2em 1em;
		background-color: #e9ecef;
		font-size: 0.9em;
	}
	.modal-body {
		padding: 0.5em;
		font-size: 0.95em;
		background-color: #f8f9fa;
		// border: solid 0.1em #adb5bd;
		> div {
			padding-left: 0.5em;
			> svg {
				color: #4fa4ff;
			}
			> span.btn {
				padding: 0.2em;
				line-height: 0.9em;
			}
			> span:last-of-type {
				font-size: 0.8em;
				vertical-align: middle;
			}
			&:hover {
				background-color: #e9ecef;
			}
			&[disabled] {
				pointer-events: none;
				> svg {
					color: #6c757d;
				}
				> span.btn {
					color: #6c757d;
				}
				> small {
					color: #6c757d;
					display: block;
					margin-left: 1em;
				}
			}
			&:first-child[disabled] > small {
				margin-left: 2em;
			}

			border-bottom: solid 0.1em #adb5bd;
		}
		min-height: 200px;
		max-height: 70vh;
		overflow: auto;
	}
	.modal-footer {
		padding: 0.2em 1em;
	}
}
#bm-kt-attach-file-view {
	.modal-header {
		background-color: #e9ecef;
		padding: 0.2em 1em;
	}
	.modal-body {
		height: 85vh;
		overflow: auto;

		&.mt-image {
			text-align: center;
		}
	}
	.modal-footer {
		padding: 0.2em 1em;
	}
}
</style>